var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":"https://glp-zf-prod.s3.amazonaws.com/config/log-glp.jpeg","alt":"GLP-ZFR","height":"50"}})}
var staticRenderFns = []

export { render, staticRenderFns }